import type { IconNode } from '../types';

/**
 * @name floppy-disks-rear
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAxOGEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmgxMGw0IDR2MTBhMiAyIDAgMCAxLTIgMloiIC8+CiAgPGNpcmNsZSBjeD0iMTQiIGN5PSIxMCIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTQgMTh2LTIiIC8+CiAgPHBhdGggZD0iTTE4IDIySDRhMiAyIDAgMCAxLTItMlY2IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/floppy-disks-rear
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const floppyDisksRear: IconNode = [
  ['path', { d: 'M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10l4 4v10a2 2 0 0 1-2 2Z', key: '1rfswv' }],
  ['circle', { cx: '14', cy: '10', r: '2', key: '1w7m6h' }],
  ['path', { d: 'M14 18v-2', key: '1e242r' }],
  ['path', { d: 'M18 22H4a2 2 0 0 1-2-2V6', key: 'pblm9e' }],
];

export default floppyDisksRear;
